<template>
    <div class="u-padding-narrow">
        <div class="u-margin-bottom"></div>
        <div class="layout layout--center | u-full-height">
            <div class="layout__item u-4/5-desk">
                <header-partial :domain="domain" class="u-text-white" />

                <div class="page-block">
                    <technical-management-tabs :step="1" :domain="domain" />

                    <dns-overview :records="records" :domain="domain" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { apiMixin } from 'relapp-api';
import { pageLoadingStatusMixin } from 'relapp-loading';
import { DnsOverview, DnsApi } from 'relapp-dns';
import { serviceMixin, HeaderPartial, servicesPageMixin } from 'relapp-technical-management';
import TechnicalManagementTabs from '@/components/technical-management/TechnicalManagementTabs.vue';

export default {
    components: {
        DnsOverview,
        HeaderPartial,
        TechnicalManagementTabs
    },
    mixins: [apiMixin, pageLoadingStatusMixin, serviceMixin, servicesPageMixin],
    props: {
        domain: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            records: 'dns/records',
            updatingStatus: 'dns/updating'
        })
    },
    /**
     * Get the meta info for the page.
     *
     * @return {object}
     */
    metaInfo() {
        return {
            title: trans('page.dns.overview', { domain: this.domain })
        };
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.getDns();
    },
    methods: {
        ...mapActions({
            setDNSDomain: 'dns/setDomain'
        }),
        /**
         * Get the DNS records.
         */
        getDns() {
            this.setDNSDomain(this.domain);
            DnsApi.get(this.routeParams)
                .then(this.finishLoading)
                .catch(error => this.handleError(error));
        }
    },
    watch: {
        /**
         * Watch if the updating status changed.
         *
         * @param {boolean} status
         */
        updatingStatus(status) {
            if (status) {
                this.startLoading();
            }

            this.finishLoading();
        }
    }
};
</script>
